import { Observable, of } from 'rxjs';
import { IdentityRepository, IdentityUser, Menu } from '@model/identity';
import { IdentityOperations } from '@model/identity/operations';

/**
 * Implementación de repositorio de identidad para pruebas
 */
export class IdentityRepositoryImplMock extends IdentityRepository {
  lastFullLogoutUrl = '';

  user: IdentityUser = {
    userName: 'Misko Hevery',
    fullName: 'Misko Hevery',
    lastAccess: '2025-06-24',
    urlLogout: '',
    fullUrlLogout: '',
    menu: JSON.stringify([
      {
        name: 'Menu',
        menuItems: [
          {
            cdresource: 1,
            contextPath: 'home',
            name: 'Inicio',
            image: 'home',
            order: 1,
            target: '',
            windowOptions: '',
            children: [],
            active: false
          },
          {
            cdresource: 5,
            contextPath: 'handbook/components',
            name: 'Componentes',
            image: 'objects-column',
            order: 5,
            target: '',
            windowOptions: '',
            children: [],
            active: false
          },
          {
            cdresource: 6,
            contextPath: 'handbook/tasks',
            name: 'Use Case: Tareas',
            image: 'pi pi-list-check',
            order: 6,
            target: '',
            windowOptions: '',
            children: [],
            active: false
          }
        ]
      }
    ])
  };

  /**
   * Retorna la información del usuario
   * @returns usuario mockeado
   */
  override getUserInfo(): Observable<IdentityUser> {
    return of(this.user);
  }

  /**
   * Retorna el menú del usuario
   * @returns menú del usuario mockeado
   */
  override getUserMenu(): Promise<Menu[]> {
    return Promise.resolve(IdentityOperations.getMenu(this.user));
  }

  /**
   * Retorna una URL de logout mockeada
   * @returns observable con la URL de logout
   */
  override getLogoutUrl(): Observable<string> {
    return of('/');
  }

  /**
   * Realiza el logout del usuario
   * @param fullUrlLogout url de logout
   */
  override fullLogout(fullUrlLogout: string): void {
    this.lastFullLogoutUrl = fullUrlLogout;
    this.user = {
      ...this.user,
      userName: '',
      fullName: '',
      lastAccess: '',
      menu: '[]',
      fullUrlLogout: ''
    };
  }
}
